"use strict";

exports.__esModule = true;
exports.default = void 0;

var _modal = _interopRequireDefault(require("./modal"));

var _bvModal = _interopRequireDefault(require("./helpers/bv-modal"));

var _modal2 = _interopRequireDefault(require("../../directives/modal/modal"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BModal: _modal.default
};
var directives = {
  BModal: _modal2.default
};

var _install = (0, _plugins.installFactory)({
  components: components,
  directives: directives
});

var _default = {
  install: function install(Vue) {
    // Inject `$bvModal` into Vue prototype
    (0, _bvModal.default)(Vue); // Install component and directive

    _install(Vue);
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/modal/index.js
// module id = 400
// module chunks = 0